import React, { useEffect } from 'react';
// HashRouter (not BrowserRouter) is required inside Capacitor. The native
// webview serves the app from https://localhost/ with no server to handle
// path-based deep links, so BrowserRouter renders a blank screen on launch
// and on any reload. HashRouter keeps all routing in the URL fragment
// (/#/app/home), which works identically on web and in the webview.
import { HashRouter } from 'react-router-dom';
import AppRoutes from './navigation';
import { Toast, ServerError, DynamicIsland } from './components/shared';
import { userStore } from './store';
import { ensureAdMobInitialised } from './lib/admob';
import './index.css';

function App() {
  // On first launch (and every cold start) we make sure there's an
  // anonymous device session, so a brand-new install can browse + read
  // without a signup. Returning users with a stored deviceId just refresh
  // their lastSeenAt server-side. Logged-in users get a device token too,
  // which kicks in if they later sign out. We also warm up AdMob so the
  // per-slot fallback in the reader has zero perceived latency on the
  // first interstitial.
  useEffect(() => {
    userStore.bootstrapDeviceSession();
    ensureAdMobInitialised();
  }, []);

  return (
    <HashRouter>
      <div className="h-screen w-screen overflow-hidden bg-[#FCFCFC]">
        <AppRoutes />
        <Toast />
        <ServerError />
        <DynamicIsland />
      </div>
    </HashRouter>
  );
}

export default App;
